import { authorizedFetch } from "./requestBuilder.js";

const API_BASE = process.env.REACT_APP_API_URL + "/api/users";

export const updateUserSettings = async (
  firstName,
  lastName,
  legalStatus,
  email,
  phone,
  billingAddress,
  vatNr,
  bankAccountNumber,
  businessName,
  bankPrefix,
  receiveNotifications
) => {
  try {
    return await authorizedFetch(`${API_BASE}/settings`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        firstName,
        lastName,
        legalStatus,
        email,
        phone,
        billingAddress,
        vatNr,
        bankAccountNumber,
        businessName,
        bankPrefix,
        receiveNotifications,
      }),
    });
  } catch (error) {
    console.error("User update error:", error);
    throw error;
  }
};

export const updateUserGoal = async (goal) => {
  try {
    return await authorizedFetch(`${API_BASE}/update_goal/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ goal }),
    });
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const getUsers = async () => {
  try {
    return await authorizedFetch(`${API_BASE}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUserSettings = async () => {
  try {
    return await authorizedFetch(`${API_BASE}/settings/`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching user settings:", error);
    throw error;
  }
};

export const deleteCurrentUser = async (confirmationPassword) => {
  try {
    return await authorizedFetch(`${API_BASE}/delete_self/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ confirmationPassword }),
    });
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

export const deleteUserById = async (userId) => {
  // TODO provide a special password to check admin access
  try {
    return await authorizedFetch(`${API_BASE}/delete/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

export const getUserPhoneNumber = async () => {
  try {
    return await authorizedFetch(`${API_BASE}/phone/`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching user phone number:", error);
    throw error;
  }
};

export const getVerificationStatus = async () => {
  try {
    return await authorizedFetch(`${API_BASE}/verification_status/`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching verification status:", error);
    throw error;
  }
};
